// extracted by mini-css-extract-plugin
export default {"list":"TranspaisInputAutocomplete_list__zMI9L","item":"TranspaisInputAutocomplete_item__TFLGV","mail":"TranspaisInputAutocomplete_mail__kOeso"};